import { useAppSelector } from '@/shared/hooks/useStore';
import { useTrans } from '@/shared/hooks/useTranslation';
import { planLabelKey, useEntitlementsQuery } from '@/viewmodel/features/entitlements';
import { toSidebarWorkspace } from '@/viewmodel/features/workspace/mappers/memberEntries';
import { selectCurrentWorkspace } from '@/viewmodel/features/workspace/state/workspacesSlice';
import type { SidebarWorkspaceView } from '@/viewmodel/features/workspace/types';

export function useSidebarWorkspaceViewModel(): SidebarWorkspaceView | null {
  const { t } = useTrans();
  const workspace = useAppSelector(selectCurrentWorkspace);
  const { entitlements, trial } = useEntitlementsQuery();
  const plan = entitlements
    ? {
        label: t(planLabelKey(entitlements.plan, trial !== null), {
          defaultValue: entitlements.plan_display_name || entitlements.plan,
        }),
        locked: trial?.expired === true,
      }
    : null;

  return toSidebarWorkspace(workspace, plan);
}
